module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-belts-e527340cda1538755cfe5bc333aa2a34.svg";